import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";


import {
     Backdrop, CircularProgress,
} from '@mui/material';


import { getDetailedReport, getSummaryReport, getDetailedReportByISO, getSummaryReportByISO, setFetchingReport, getSettlementSummaryReport } from '../../../redux/actions/ExportActions';
import { fetchAllTerminals } from '../../../redux/actions/TerminalActions';
import { fetchIsos } from "../../../redux/actions/DropdownActions";
import { fetchMerchants } from '../../../redux/actions/DropdownActions';
import { uploadReport } from '../../../redux/actions/UploadActions';
import { setSnackbar } from "../../../redux/actions/SnackbarAction";

import addDays from 'date-fns/addDays';
import moment from 'moment';
import CollapsibleTable from '../Table/MaterialColapseTable';
import { Panel, PanelHeader, PanelBody } from '../../header/panel/panel';


const SettlementReport = (props) => {



    const [isoValue, setIsoValue] = useState('');
    const [merchantID, setMerchantID] = useState('')
    const [isDate, setIsDate] = useState(false);
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')

    const [isoError, setIsoError] = useState(false);
    const [merchantError, setMerchantError] = useState(false)
    const [, setStartError] = useState(false)
    const [, setEndError] = useState(false)
    const [businessError,] = useState(false)
    const [reportError,] = useState(false)

    const [merchantDropdown, setMerchantDropdown] = useState([])
    const [terminalDropdown, setTerminalDropdown] = useState([])

    const [minDate,] = useState(new Date());
    const [maxDate, setMaxDate] = useState(new Date());
    const [toMinDate, setToMinDate] = useState(new Date());
    const [toMaxDate, setToMaxDate] = useState(new Date());

    const [, setInfoModelOpen] = useState(false);


    const [maxDays, setMaxDays] = useState(31)

    useEffect(() => {
        setMaxDate(moment(new Date()).format('YYYY-MM-DD'))
        if (props.LOGINREDUCER.USER.role === 1) {
            setMaxDays(90)
        }
        props.fetchAllTerminals()
        props.fetchIsos()
    }, [])


    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value

        switch (targetName) {

            case 'isoID':
                if (targetValue) {

                    setIsoError(false)
                    setIsoValue(targetValue);
                    let merchants = props.DROPDOWNREDUCER.isosData.filter(iso => {
                        return String(iso.isoID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                    })

                    if (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 2 || props.LOGINREDUCER.USER.role === 6) {
                        console.log(merchants[0]?.merchants)
                        setMerchantDropdown(merchants[0]?.merchants)

                        console.log('merchant drop : ' + merchantDropdown)
                    } else {
                        setMerchantDropdown(merchants[0]?.merchants)
                    }
                }
                break;

            case 'merchantID':
                if (targetValue) {
                    setMerchantError(false);
                    setMerchantID(targetValue)
                    props.fetchMerchants(targetValue)
                }
            // falls through

            case 'startDate':
                if (moment(new Date(targetValue)).isBefore(new Date())) {
                    setStartDate(targetValue);
                    setStartError(false)
                    if (moment(addDays(new Date(targetValue), maxDays)).isBefore(new Date())) {
                        setToMaxDate(moment(addDays(new Date(targetValue), maxDays)).format('YYYY-MM-DD'))
                    } else {
                        setToMaxDate(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setToMinDate(moment(addDays(new Date(targetValue), 1)).format('YYYY-MM-DD'))
                } else {
                    setStartError(true)
                }

                break;

            case 'endDate':

                if (moment(addDays(new Date(startDate), maxDays)).isAfter(new Date(targetValue))) {
                    setEndError(false)
                    setEndDate(targetValue);
                } else {
                    setEndError(true)
                }
                break;
            case 'daterange':
                setIsDate(event.target.checked)
                break;

            default:
                break;
        }
    }

    const handleSubmit = () => {
        let body = {}

        body.dateRange = isDate
        body.merchantID = merchantID

        if (startDate) {
            body.startDate = startDate
        } else {
            setStartError(true)
        }
        if (isDate) {
            if (endDate) {
                body.endDate = endDate
            } else {
                setEndError(true)
            }
        }

        console.log('Body : {} ', body)

        if (merchantID && merchantID === "ALL MERCHANTS") {

            body.byISO = true;
            body.isoID = isoValue;

            if (!isoError && !reportError && !businessError) {

                if ((isDate && moment(addDays(new Date(startDate), maxDays)).isAfter(new Date(endDate))) || !isDate) {
                    props.setFetchingReport(true)
                    props.getSettlementSummaryReport(body)
                } else {
                    props.setSnackbar(true, 'error', 'Maximum Days Should be less than or Equal to 1 Month')
                }
            } else {
                props.setSnackbar(true, 'error', 'Please select all fields')

            }

        } else {

            body.merchantID = merchantID

            if (!merchantError) {

                console.log('Body 2 : {} ', body)


                if ((isDate && moment(addDays(new Date(startDate), maxDays)).isAfter(new Date(endDate))) || !isDate) {
                    props.setFetchingReport(true)
                    props.getSettlementSummaryReport(body)
                } else {
                    props.setSnackbar(true, 'error', 'Maximum Days Should be less than or Equal to 1 Month')
                }
            } else {
                props.setSnackbar(true, 'error', 'Please select all fields')

            }
        }

    }


    const handleTerminalDrop = () => {

        if (props.DROPDOWNREDUCER.merchantsData && props.DROPDOWNREDUCER.merchantsData.length) {
            setTerminalDropdown([{ terminalID: "ALL TERMINALS" }, ...props.DROPDOWNREDUCER.merchantsData])
            console.log(terminalDropdown)
        } else {
            setTerminalDropdown([])
        }
    }


    let EXPORTFORM = (


        <Panel>

            <PanelHeader>


                <div className="row mb-0">

                    <div className="col-xl-8">
                        Export Report
                    </div>
                    <div className="col-xl-4">
                        <div className="align-item-right"> <i className="icon-info h4 d-block" onClick={() => setInfoModelOpen(true)}></i>
                            {/* {INFO_DATA} */}
                        </div>
                    </div>
                </div>


            </PanelHeader>

            <PanelBody>


                <>
                    <div className="row mb-3">
                        <div className="col-xl-12">
                            <select className="form-select"
                                value={isoValue ? isoValue : ''}
                                onChange={handleChange}
                                name='isoID'
                            >
                                <option value=''>Select ISO</option>

                                {props.DROPDOWNREDUCER.isosData.map((option) => (
                                    <option key={option.isoID} value={option.isoID}>
                                        {option.isoName}
                                    </option>
                                ))}

                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-xl-12">
                            <select className="form-select"
                                value={merchantID ? merchantID : ''}
                                onChange={handleChange}
                                name='merchantID'
                                onBlur={handleTerminalDrop}

                            >

                                <option value=''>Select Merchant</option>
                                {(props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 2 || props.LOGINREDUCER.USER.role === 3 || props.LOGINREDUCER.USER.role === 6 || props.LOGINREDUCER.USER.role === 7) ? <option value='ALL MERCHANTS'>ALL MERCHANTS</option> : null}
                                {merchantDropdown.map((option) => (
                                    <option key={option.merchantID} value={option.merchantID}>
                                        {option.merchantName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </>


                <div className="row mb-3">

                    <div className="col-xl-12">
                        <label className="form-check-label" >
                            <b>Enable Date Range</b>&nbsp;&nbsp;&nbsp;
                            <input className="form-check-input" type="checkbox" checked={isDate} onChange={handleChange} name='daterange' >
                            </input>
                        </label>

                    </div>

                </div>
                <div className="row mb-3">
                    <div className="col-xl-12">
                        <label className="form-check-label" >
                            <b>{isDate ? 'Start ' : ''} Date</b>
                        </label>
                        <input
                            max={maxDate}
                            min={minDate}
                            defaultValue={maxDate}
                            // value = {startDate ? startDate : ''}
                            id="startDate"
                            label="Start Date"
                            type="date"
                            onChange={handleChange}
                            name="startDate"
                            className="form-control fs-13px"
                        ></input>
                    </div>
                </div>

                {isDate ? <div className="row mb-3">
                    <div className="col-xl-12">
                        <label className="form-check-label" >
                            <b>End Date</b>
                        </label>

                        <input
                            defaultValue={endDate}
                            min={toMinDate}
                            max={toMaxDate}
                            id="endDate"
                            label="End Date"
                            type="date"
                            onChange={handleChange}
                            name="endDate"
                            className="form-control fs-13px"
                        ></input>
                    </div>
                </div> : null}


                <button className="btn btn-primary w-100px me-5px" onClick={handleSubmit}>Run Report</button>

            </PanelBody>

        </Panel>



        //     <TextField
        //         id="outlined-select-iso"
        //         select
        //         label="ISO"
        //         value={isoValue ? isoValue : ''}
        //         error={isoError}
        //         onChange={handleChange}
        //         size='small'
        //         fullWidth
        //         name='isoID'
        //         sx={{
        //             width: { sm: 250, md: 250 },
        //             "& .MuiInputBase-root": {
        //                 height: 40
        //             }
        //         }}
        //     >
        //         {props.DROPDOWNREDUCER.isosData.map((option) => (
        //             <MenuItem key={option.isoID} value={option.isoID}>
        //                 {option.isoName}
        //             </MenuItem>
        //         ))}
        //     </TextField>
        // </Grid>

        // <Grid item style={{ minWidth: 150 }}>

        //     <TextField
        //         id="outlined-select-merchant"
        //         select
        //         label="Merchant"
        //         value={merchantID ? merchantID : ''}
        //         error={merchantError}
        //         onChange={handleChange}
        //         size='small'
        //         fullWidth
        //         name='merchantID'
        //         onBlur={handleTerminalDrop}
        //         sx={{
        //             width: { sm: 250, md: 250 },
        //             "& .MuiInputBase-root": {
        //                 height: 40
        //             }
        //         }}
        //     >

        //         {merchantDropdown.map((option) => (
        //             <MenuItem key={option.merchantID} value={option.merchantID}>
        //                 {option.merchantName}
        //             </MenuItem>
        //         ))}
        //     </TextField>
        // </Grid>



        // <Grid item style={{ maxWidth: 150 }}>
        //     <FormGroup sx={{
        //         width: { sm: 150, md: 150 },
        //         "& .MuiInputBase-root": {
        //         }
        //     }}>
        //         <FormControlLabel
        //             control={<Checkbox checked={isDate}
        //                 onChange={handleChange}
        //                 name='daterange'
        //             />} label="Date Range" />
        //     </FormGroup>

        // </Grid>

        // <Grid item style={{ minWidth: 150 }}>
        //     <TextField
        //         InputProps={{ inputProps: { max: maxDate } }}
        //         defaultValue={maxDate}
        //         id="dateFrom"
        //         label="Start Date"
        //         type="date"
        //         onChange={handleChange}
        //         name="startDate"
        //         error={startError}
        //         sx={{
        //             width: { sm: 150, md: 150 },
        //             "& .MuiInputBase-root": {
        //                 height: 40
        //             }
        //         }} InputLabelProps={{
        //             shrink: true,
        //         }}
        //     />
        // </Grid>


        // {isDate ?
        //     <Grid item style={{ minWidth: 150 }}>

        //         <TextField
        //             InputProps={{ inputProps: { min: toMinDate, max: toMaxDate } }}
        //             defaultValue={toMinDate}
        //             id="dateTo"
        //             label="End Date"
        //             type="date"
        //             error={endError}
        //             onChange={handleChange}
        //             name="endDate"
        //             sx={{
        //                 width: { sm: 150, md: 150 },
        //                 "& .MuiInputBase-root": {
        //                     height: 40
        //                 }
        //             }}
        //             InputLabelProps={{
        //                 shrink: true,
        //             }}
        //         />
        //     </Grid> :
        //     <Grid item style={{ minWidth: 154 }} />}

        // <Grid item style={{ minWidth: 150 }}>
        //     <Button
        //         fullWidth
        //         onClick={handleSubmit} variant='contained'
        //         sx={{
        //             width: { sm: 150, md: 150 },
        //             "& .MuiInputBase-root": {
        //                 height: 40
        //             }
        //         }}>Run Report</Button>

    )


    return (

        <div className="row mb-3">

            {
                props.EXPORTREDUCER.fetching ?
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={props.EXPORTREDUCER.fetching}
                    // onClick={handleClose}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop> : null
            }


            <div className="col-xl-2">
                {EXPORTFORM}
            </div>
            <div className="col-xl-10">

                {/* <Panel> */}
                    <CollapsibleTable data={props.EXPORTREDUCER.settlementSummary}></CollapsibleTable>
                {/* </Panel> */}
            </div>
        </div>

    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchIsos,
    setSnackbar,
    uploadReport,
    fetchMerchants,
    fetchAllTerminals,
    getDetailedReport,
    setFetchingReport,
    getSummaryReport,
    getSummaryReportByISO,
    getDetailedReportByISO,
    getSettlementSummaryReport
}
export default connect(mapStateToProps, mapDispatchToProps)(SettlementReport);

